module.exports = __webpack_public_path__ + "img/list-img3.db8e9016.png";